function handleSocialMediaShare() {
  const shareButtons = {
    facebook: document.getElementById('share-facebook'),
    linkedin: document.getElementById('share-linkedin'),
    twitter: document.getElementById('share-twitter'),
    email: document.getElementById('share-email'),
    shareNeededInfo: document.querySelector('.article-share__icons')
  };

  if (!shareButtons.shareNeededInfo) return;

  const articleTitle = shareButtons.shareNeededInfo.getAttribute("data-title");
  const articleURL = shareButtons.shareNeededInfo.getAttribute("data-url");

  if(shareButtons.facebook) {
    shareButtons.facebook.addEventListener('click', () => {
        const url = 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(articleURL);
        window.open(url, '_blank', 'width=800,height=600');
    });
  }

  if(shareButtons.linkedin) {
  shareButtons.linkedin.addEventListener('click', () => {
    const url = 'https://www.linkedin.com/shareArticle?mini=true&url=' + encodeURIComponent(articleURL);
    window.open(url, '_blank', 'width=800,height=600');
  });
}

 if(shareButtons.twitter) {
  shareButtons.twitter.addEventListener('click', () => {
    const url = 'https://twitter.com/intent/tweet?url=' + encodeURIComponent(articleURL);
    window.open(url, '_blank', 'width=800,height=600');
  });
}

if(shareButtons.email) {
  shareButtons.email.addEventListener('click', () => {
    let dataSubject = shareButtons.email.dataset.subject;
    let dataBody = shareButtons.email.dataset.body;

    const subject = encodeURIComponent(dataSubject + ' ' + articleTitle);
    const body = encodeURIComponent(dataBody + ' ' + "\n" + articleURL);

    window.location.href = `mailto:?subject=${subject}&body=${body}`;
  });
}
}

document.addEventListener("DOMContentLoaded", () => {
  handleSocialMediaShare();
});